module.exports = __webpack_public_path__ + "img/KD.a14fa253.png";